webpackJsonp([1],{

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("7t+N");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: ./node_modules/popper.js/dist/esm/popper.js
var popper = __webpack_require__("Zgw8");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ea16abd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app_header.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app_header"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var app_header = (esExports);
// CONCATENATED MODULE: ./src/components/app_header.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  app_header,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_app_header = (Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0939ac6f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app_footer.vue
var app_footer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app_footer"}})}
var app_footer_staticRenderFns = []
var app_footer_esExports = { render: app_footer_render, staticRenderFns: app_footer_staticRenderFns }
/* harmony default export */ var app_footer = (app_footer_esExports);
// CONCATENATED MODULE: ./src/components/app_footer.vue
var app_footer_normalizeComponent = __webpack_require__("VU/8")
/* script */
var app_footer___vue_script__ = null
/* template */

/* template functional */
var app_footer___vue_template_functional__ = false
/* styles */
var app_footer___vue_styles__ = null
/* scopeId */
var app_footer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var app_footer___vue_module_identifier__ = null
var app_footer_Component = app_footer_normalizeComponent(
  app_footer___vue_script__,
  app_footer,
  app_footer___vue_template_functional__,
  app_footer___vue_styles__,
  app_footer___vue_scopeId__,
  app_footer___vue_module_identifier__
)

/* harmony default export */ var components_app_footer = (app_footer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/app_nav.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var app_nav = ({
    data: function data() {
        return {};
    },

    methods: {
        sidebarActive: function sidebarActive() {
            this.$store.commit('setSidebar', 'active');
        }
    },
    computed: {
        showToggleButtonByRoute: function showToggleButtonByRoute() {
            var route_name = this.$route.name;
            if (route_name === 'blog' || route_name === 'blog_title') {
                //only show button if under blog
                return true;
            } else {
                return false;
            }
        }
    },
    mounted: function mounted() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58255854","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app_nav.vue
var app_nav_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app_nav"}},[_c('ul',{staticClass:"nav justify-content-end"},[(_vm.showToggleButtonByRoute)?_c('li',{staticClass:"nav-item",attrs:{"id":"toggleButton"}},[_c('a',{staticClass:"nav-link",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.sidebarActive}},[_c('i',{staticClass:"fa fa-bars",attrs:{"aria-hidden":"true"}})])]):_vm._e(),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/me"}},[_vm._v(_vm._s(this.$store.state.navText[0]))])],1),_vm._v(" "),(this.$store.state.enableResume)?_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/resume"}},[_vm._v(_vm._s(this.$store.state.navText[1]))])],1):_vm._e(),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/blog/"}},[_vm._v(_vm._s(this.$store.state.navText[2]))])],1)])])}
var app_nav_staticRenderFns = []
var app_nav_esExports = { render: app_nav_render, staticRenderFns: app_nav_staticRenderFns }
/* harmony default export */ var components_app_nav = (app_nav_esExports);
// CONCATENATED MODULE: ./src/components/app_nav.vue
var app_nav_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var app_nav___vue_template_functional__ = false
/* styles */
var app_nav___vue_styles__ = null
/* scopeId */
var app_nav___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var app_nav___vue_module_identifier__ = null
var app_nav_Component = app_nav_normalizeComponent(
  app_nav,
  components_app_nav,
  app_nav___vue_template_functional__,
  app_nav___vue_styles__,
  app_nav___vue_scopeId__,
  app_nav___vue_module_identifier__
)

/* harmony default export */ var src_components_app_nav = (app_nav_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//



window.Popper = popper["a" /* default */];
window.$ = jquery_default.a;
__webpack_require__("K3J8");




/* harmony default export */ var App = ({
    name: 'app',
    components: {
        appHeader: components_app_header,
        appNav: src_components_app_nav,
        appFooter: components_app_footer
    },
    methods: {},
    data: function data() {
        return {};
    },

    computed: {
        addhighlight: function addhighlight() {
            if (this.$store.state.allArticlesFetched) {
                jquery_default()('pre code').each(function (i, block) {
                    hljs.highlightBlock(block);
                });
            }
        }
    },
    mounted: function mounted() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ed9dc6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',[_c('appHeader'),_vm._v(" "),_c('appNav'),_vm._v(" "),_c('div',[_c('router-view')],1),_vm._v(" "),_c('appFooter',[_vm._v(_vm._s(_vm.addhighlight))])],1)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = null
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/me.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var me = ({
	data: function data() {
		return {};
	},
	mounted: function mounted() {},

	computed: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d8938c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/me.vue
var me_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"me"}},[(this.$store.state.meAnimation)?_c('div',{staticClass:"scene"},[_c('span',{staticClass:"cloud cloud--small"}),_vm._v(" "),_c('svg',{staticClass:"plane",attrs:{"xmlns":"http://www.w3.org/2000/svg","id":"plane","viewBox":"0 0 104 47","x":"0","y":"0","width":"104","height":"47","background-color":"#ffffff00"}},[_c('g',{attrs:{"id":"avion"}},[_c('path',{attrs:{"d":"M20 36C25 38 69 43 80 40 92 38 106 33 104 21 103 13 95 13 90 9 85 5 79 2 76 1 70-1 65 0 60 2 57 3 25 14 23 13 21 12 12 2 9 3 5 4 1 5 1 6 2 7 15 34 20 36Z","fill":"#0085b2"}}),_vm._v(" "),_c('path',{attrs:{"d":"M23 36C28 37 69 43 80 40 88 38 98 34 102 29 82 32 22 36 23 36Z","stroke":"#ffffff00","stroke-width":"1","fill":"#14647f"}}),_vm._v(" "),_c('path',{attrs:{"d":"M42 39C48 40 60 40 67 40 71 32 72 26 72 26L44 29C44 29 44 35 42 39Z","stroke":"#ffffff00","stroke-width":"1","fill":"#0c3b4d"}}),_vm._v(" "),_c('path',{attrs:{"d":"M7 16C7 16 9 20 10 22 13 27 16 13 16 13L7 16Z","stroke":"#ffffff00","stroke-width":"1","fill":"#0c3b4d"}}),_vm._v(" "),_c('path',{attrs:{"d":"M40 29C40 29 41 34 34 42 27 51 48 46 58 39 74 28 72 25 72 25L40 29Z","stroke":"#ffffff00","stroke-width":"1","fill":"#006e96"}}),_vm._v(" "),_c('path',{attrs:{"d":"M5 14C5 14 6 15 3 19 1 22 10 20 13 17 19 11 17 11 17 11L5 14Z","stroke":"#ffffff00","stroke-width":"1","fill":"#006e96"}}),_vm._v(" "),_c('path',{attrs:{"d":"M90 10C88 8 83 4 80 3 78 3 68 7 68 8 70 12 80 8 90 10Z","stroke":"#ffffff00","stroke-width":"1","fill":"#0c3b4d"}}),_vm._v(" "),_c('path',{attrs:{"d":"M89 9C87 7 82 3 79 2 77 2 67 6 67 7 69 11 79 7 89 9Z","stroke":"#ffffff00","stroke-width":"1","fill":"#afe2ff"}})])]),_vm._v(" "),_c('span',{staticClass:"cloud cloud--medium"}),_vm._v(" "),_c('span',{staticClass:"cloud cloud--large"})]):_vm._e(),_vm._v(" "),(this.$store.state.showImg)?_c('img',{attrs:{"src":'../../static/data/img/' + this.$store.state.meImg,"alt":"Sorry, image not found","id":"avatar"}}):_vm._e(),_vm._v(" "),_c('p',[_vm._v(_vm._s(this.$store.state.meText))])])}
var me_staticRenderFns = []
var me_esExports = { render: me_render, staticRenderFns: me_staticRenderFns }
/* harmony default export */ var components_me = (me_esExports);
// CONCATENATED MODULE: ./src/components/me.vue
var me_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var me___vue_template_functional__ = false
/* styles */
var me___vue_styles__ = null
/* scopeId */
var me___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var me___vue_module_identifier__ = null
var me_Component = me_normalizeComponent(
  me,
  components_me,
  me___vue_template_functional__,
  me___vue_styles__,
  me___vue_scopeId__,
  me___vue_module_identifier__
)

/* harmony default export */ var src_components_me = (me_Component.exports);

// EXTERNAL MODULE: ./node_modules/showdown/dist/showdown.js
var showdown = __webpack_require__("HKE2");
var showdown_default = /*#__PURE__*/__webpack_require__.n(showdown);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/resume.vue
//
//
//


var converter = new showdown_default.a.Converter();

/* harmony default export */ var resume = ({
    data: function data() {
        return {};
    },
    mounted: function mounted() {},

    computed: {
        getResume: function getResume() {
            if (this.$store.state.resumeData) {
                return converter.makeHtml(this.$store.state.resumeData);
            }
        }
    }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59be8714","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/resume.vue
var resume_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.$store.state.enableResume)?_c('div',{attrs:{"id":"resume"},domProps:{"innerHTML":_vm._s(_vm.getResume)}}):_vm._e()}
var resume_staticRenderFns = []
var resume_esExports = { render: resume_render, staticRenderFns: resume_staticRenderFns }
/* harmony default export */ var components_resume = (resume_esExports);
// CONCATENATED MODULE: ./src/components/resume.vue
var resume_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var resume___vue_template_functional__ = false
/* styles */
var resume___vue_styles__ = null
/* scopeId */
var resume___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var resume___vue_module_identifier__ = null
var resume_Component = resume_normalizeComponent(
  resume,
  components_resume,
  resume___vue_template_functional__,
  resume___vue_styles__,
  resume___vue_scopeId__,
  resume___vue_module_identifier__
)

/* harmony default export */ var src_components_resume = (resume_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/define-property.js
var define_property = __webpack_require__("C4MV");
var define_property_default = /*#__PURE__*/__webpack_require__.n(define_property);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/sidebar.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var sidebar = ({
    data: function data() {
        return {
            // search:''
        };
    },
    methods: {
        clearResult: function clearResult() {
            //make sure every time load a new article, go to the top of article
            window.scrollTo(0, 0);

            //clear search
            this.$store.commit('setSearch', null);
            this.$store.commit('setShowSearch', false);
        }
    },
    props: ['title'],
    watch: {},
    computed: {
        getAllTypes: function getAllTypes() {
            var final_directory = {}; //whole directory

            // only do this if exist
            if (this.$store.state.allArticlesFetched) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = get_iterator_default()(this.$store.state.allTypes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var i = _step.value;

                        if (!final_directory[i]) {
                            define_property_default()(final_directory, i, {
                                value: [],
                                writable: true,
                                enumerable: true,
                                configurable: true
                            });
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = get_iterator_default()(this.$store.state.allArticleTitle), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var val = _step2.value;

                        var articleDetails = this.$store.state.allDetails[val];
                        final_directory[articleDetails['type']].push(articleDetails);
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }
            return final_directory;
        },
        sidebarStatus: function sidebarStatus() {
            return this.$store.state.sidebarStatus;
        },
        getActiveTitle: function getActiveTitle() {
            if (this.title) {
                return this.title;
            }
        },
        getActiveType: function getActiveType() {
            var type = '';
            if (this.$store.state.allDetails && this.title) {
                type = this.$store.state.allDetails[this.title]['type'];
            }
            return type;
        },

        search: {
            get: function get() {
                return this.$store.state.search;
            },
            set: function set(value) {
                this.$store.dispatch('actionSetSearch', {
                    value: value
                });
            }
        }
    },
    mounted: function mounted() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b692509","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar.vue
var sidebar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.sidebarStatus,attrs:{"id":"sidebar"}},[_c('div',{staticClass:"sidebar-header"},[_c('div',{staticClass:"search"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],attrs:{"type":"text","placeholder":"Type to search","id":"serarch_input"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.getAllTypes)?_c('ul',{staticClass:"list-unstyled components"},_vm._l((_vm.getAllTypes),function(val,key){return _c('li',{class:(key==_vm.getActiveType)?'active':''},[_c('a',{attrs:{"href":(val.length>0)?('#' + key.trim().replace(/ /g,'')):'javascript:void(0);',"data-toggle":(val.length>0)?'collapse':'',"aria-expanded":(val.length>0)?'false':''}},[_vm._v("\n               "+_vm._s(key)+"\n            ")]),_vm._v(" "),((val.length>0))?_c('ul',{staticClass:"list-unstyled collapse",class:(key==_vm.getActiveType)?'show':'',attrs:{"id":key.trim().replace(/ /g,'')}},_vm._l((val),function(val2,key2){return _c('li',{class:(val2['title']==_vm.getActiveTitle)?'active':'',on:{"click":function($event){_vm.clearResult()}}},[_c('router-link',{attrs:{"to":{name: 'blog_title', params: {title: val2.title}}}},[_vm._v("\n                        "+_vm._s(val2.title)+"\n                    ")])],1)})):_vm._e()])})):_vm._e()])}
var sidebar_staticRenderFns = []
var sidebar_esExports = { render: sidebar_render, staticRenderFns: sidebar_staticRenderFns }
/* harmony default export */ var components_sidebar = (sidebar_esExports);
// CONCATENATED MODULE: ./src/components/sidebar.vue
var sidebar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var sidebar___vue_template_functional__ = false
/* styles */
var sidebar___vue_styles__ = null
/* scopeId */
var sidebar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var sidebar___vue_module_identifier__ = null
var sidebar_Component = sidebar_normalizeComponent(
  sidebar,
  components_sidebar,
  sidebar___vue_template_functional__,
  sidebar___vue_styles__,
  sidebar___vue_scopeId__,
  sidebar___vue_module_identifier__
)

/* harmony default export */ var src_components_sidebar = (sidebar_Component.exports);

// EXTERNAL MODULE: ./node_modules/showdown-highlight/lib/index.js
var lib = __webpack_require__("udZ0");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/blog_article.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// showdown.setFlavor('github'); //set global falvor
var blog_article_converter = new showdown_default.a.Converter({
    headerLevelStart: 2, //start with h2
    // literalMidWordUnderscores: true, 
    // literalMidWordAsterisks: true,
    strikethrough: true, //allow ~~a~~
    tables: true,
    tasklists: true,
    smartIndentationFix: true,
    // simpleLineBreaks: true,
    requireSpaceBeforeHeadingText: true,
    openLinksInNewWindow: true,
    emoji: true,
    extensions: [lib_default.a],
    parseImgDimensions: true

});

/* harmony default export */ var blog_article = ({
    props: ['title'],
    data: function data() {
        return {
            allArticles: this.$store.state.allArticles
        };
    },
    methods: {
        //control of sidebar [not a good way]
        sidebarDisable: function sidebarDisable() {
            if (this.$store.state.sidebarStatus == 'active') {
                this.$store.commit('setSidebar', 'disable');
            }
        },
        clearResult: function clearResult() {
            //make sure every time load a new article, go to the top of article
            window.scrollTo(0, 0);

            //clear search
            this.$store.commit('setSearch', null);
            this.$store.commit('setShowSearch', false);
        }
    },
    computed: {
        getOneTitle: function getOneTitle() {
            if (this.title) {
                return this.title;
            }
        },
        getOneDate: function getOneDate() {
            if (this.$store.state.allArticlesFetched) {
                return this.$store.state.allDetails[this.title].date;
            }
        },
        getOneArticle: function getOneArticle() {
            if (this.$store.state.allArticlesFetched) {
                var article = blog_article_converter.makeHtml(this.$store.state.allArticles[this.title]);
                //add path to img using regex
                var myRegex = /<img[^>]+src="?([^"\s]+)"?[^\/]*\/>/g;
                var src = '';
                var imgPath = this.$store.state.imgPath;

                while (src = myRegex.exec(article)) {
                    var img = src[1];
                    //escape outside image
                    if (!img.startsWith('http') && !img.startsWith('https')) {
                        article = article.replace(src[1], imgPath + src[1]);
                    }
                }

                return article;
            }
        },
        showSearch: function showSearch() {
            return this.$store.state.searchResults.showSearch;
        },
        hasSearchResult: function hasSearchResult() {
            return this.$store.state.searchResults.hasResult;
        },
        getSearchResult: function getSearchResult() {
            return this.$store.state.searchResults.results;
        }
    },
    mounted: function mounted() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-547a6bae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blog_article.vue
var blog_article_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"blog_article"},on:{"click":_vm.sidebarDisable}},[(_vm.showSearch)?_c('div',{staticClass:"article-inner"},[(_vm.hasSearchResult)?_c('ul',_vm._l((_vm.getSearchResult),function(val,key){return _c('li',[_c('p',{on:{"click":function($event){_vm.clearResult()}}},[_c('router-link',{attrs:{"to":encodeURI('/blog/' + key)}},[_vm._v(_vm._s(key))])],1),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(val.content)}})])})):_c('h2',[_vm._v("\n            No results found for '"+_vm._s(this.$store.state.search)+"'\n        ")])]):(_vm.getOneTitle)?_c('div',{staticClass:"article-inner"},[_c('p',{staticClass:"date"},[_vm._v(_vm._s(_vm.getOneDate))]),_vm._v(" "),_c('h1',{attrs:{"id":"title"}},[_vm._v(_vm._s(_vm.getOneTitle))]),_vm._v(" "),_c('div',[_c('p',{staticClass:"article-text",domProps:{"innerHTML":_vm._s(_vm.getOneArticle)}})])]):_vm._e()])}
var blog_article_staticRenderFns = []
var blog_article_esExports = { render: blog_article_render, staticRenderFns: blog_article_staticRenderFns }
/* harmony default export */ var components_blog_article = (blog_article_esExports);
// CONCATENATED MODULE: ./src/components/blog_article.vue
var blog_article_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var blog_article___vue_template_functional__ = false
/* styles */
var blog_article___vue_styles__ = null
/* scopeId */
var blog_article___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var blog_article___vue_module_identifier__ = null
var blog_article_Component = blog_article_normalizeComponent(
  blog_article,
  components_blog_article,
  blog_article___vue_template_functional__,
  blog_article___vue_styles__,
  blog_article___vue_scopeId__,
  blog_article___vue_module_identifier__
)

/* harmony default export */ var src_components_blog_article = (blog_article_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/blog.vue
//
//
//
//
//
//
//



/* harmony default export */ var blog = ({
    data: function data() {
        return {};
    },
    components: {
        sidebar: src_components_sidebar,
        blogarticle: src_components_blog_article
    },
    methods: {},
    mounted: function mounted() {
        this.$store.commit('setSidebar', 'disable'); //alway disable sidebar first
    },

    computed: {
        getArticleTitle: function getArticleTitle() {
            var title = null;
            if (this.$route.params.title) {
                title = this.$route.params.title;
            } else {
                var allArticleTitle = this.$store.state.allArticleTitle;
                if (allArticleTitle) {
                    title = allArticleTitle[Math.floor(Math.random() * allArticleTitle.length)]; //random get one
                    this.$route.params.title = title;
                }
            }
            return title;
        }
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3861da8f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/blog.vue
var blog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"blog"}},[_c('sidebar',{attrs:{"title":_vm.getArticleTitle}}),_vm._v(" "),_c('blogarticle',{attrs:{"title":_vm.getArticleTitle}})],1)}
var blog_staticRenderFns = []
var blog_esExports = { render: blog_render, staticRenderFns: blog_staticRenderFns }
/* harmony default export */ var components_blog = (blog_esExports);
// CONCATENATED MODULE: ./src/components/blog.vue
var blog_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var blog___vue_template_functional__ = false
/* styles */
var blog___vue_styles__ = null
/* scopeId */
var blog___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var blog___vue_module_identifier__ = null
var blog_Component = blog_normalizeComponent(
  blog,
  components_blog,
  blog___vue_template_functional__,
  blog___vue_styles__,
  blog___vue_scopeId__,
  blog___vue_module_identifier__
)

/* harmony default export */ var src_components_blog = (blog_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js






vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
    routes: [{ path: '/', name: 'home', redirect: '/me' }, { path: '/me', name: 'me', component: src_components_me }, { path: '/resume', name: 'resume', component: src_components_resume }, { path: '/blog', name: 'blog', component: src_components_blog }, { path: '/blog/:title', name: 'blog_title', component: src_components_blog }]
}));
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/values.js
var values = __webpack_require__("gRE1");
var values_default = /*#__PURE__*/__webpack_require__.n(values);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./src/vuex/store.js






vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var state = {
    sidebarStatus: '',
    allTypes: [],
    allDetails: {},
    allArticles: {},
    allArticleTitle: [],
    articlePath: '../../static/data/articles/',
    allArticlesFetched: false,
    imgPath: 'static/data/img/',
    resumeData: '',

    pageTitle: '',

    enableResume: false,

    meAnimation: false,
    showImg: false,
    meImg: undefined,
    meText: undefined,
    navText: ['Me', 'Resume', 'Blog'],

    //search
    maxReturnLength: 200,
    search: null,
    searchResults: {
        showSearch: false
    }
};

var getters = {
    getAllArticles: function getAllArticles(state) {
        return state.allArticles;
    }
};

var mutations = {

    //search
    setSearch: function setSearch(state, value) {
        state.search = value;
    },
    setSearchResults: function setSearchResults(state, value) {
        state.searchResults = value;
    },
    setShowSearch: function setShowSearch(state, value) {
        state.searchResults.showSearch = value;
    },
    setSidebar: function setSidebar(state, value) {
        state.sidebarStatus = value;
    },
    setResume: function setResume(state, value) {
        state.enableResume = value;
    },
    setNavText: function setNavText(state, value) {
        state.navText = value;
    },
    setPageTitle: function setPageTitle(state, value) {
        state.pageTitle = value;
        document.title = value; //set title
    },
    setShowImg: function setShowImg(state, value) {
        state.showImg = value;
    },
    setMeImg: function setMeImg(state, value) {
        state.meImg = value;
    },
    setMeAnimation: function setMeAnimation(state, value) {
        state.meAnimation = value;
    },
    setMeText: function setMeText(state, value) {
        state.meText = value;
    },
    setResumeData: function setResumeData(state, value) {
        state.resumeData = value;
    },
    setAllDetails: function setAllDetails(state, value) {
        state.allDetails[value.title] = value;
    },
    setAllTypes: function setAllTypes(state, value) {
        state.allTypes.push(value);
    },
    setAllArticles: function setAllArticles(state, value) {
        state.allArticles[value.title] = value.content;
    },
    setAllArticleTitle: function setAllArticleTitle(state, value) {
        state.allArticleTitle.push(value);
    },
    setAllArticlesFetched: function setAllArticlesFetched(state, value) {
        state.allArticlesFetched = value;
    }
};

var actions = {
    actionFetch: function actionFetch(store) {

        //getting all settings
        axios_default.a.get('../../static/config/config.json').then(function (response) {

            var error_info = '';

            //resume
            var enable_resume = response.data.enable_resume;
            if ($.type(enable_resume) !== 'boolean') {
                error_info += "'enable_resume' must be a boolean (without quote) in config.json\n";
            } else {
                store.commit('setResume', enable_resume);
            }

            //navbar
            var nav_text = response.data.nav_text;
            if ($.type(nav_text) !== 'array' || nav_text.length !== 3) {
                error_info += "'nav_text' must be a legnth 3 array in config.json\n";
            } else {
                store.commit('setNavText', nav_text);
            }

            //title
            var page_title = response.data.page_title;
            if ($.type(page_title) !== 'string') {
                error_info += "'page_title' must be a string in config.json\n";
            } else {
                store.commit('setPageTitle', page_title);
            }

            //animation
            var me_animation = response.data.me_animation;
            if ($.type(me_animation) !== 'boolean') {
                error_info += "'me_animation' must be a boolean (without quote) in config.json\n";
            } else {
                store.commit('setShowImg', !me_animation);
                store.commit('setMeAnimation', me_animation);
            }

            //text
            var me_text = response.data.me_text;
            if ($.type(me_text) !== 'string') {
                error_info += "'me_text' must be a string in config.json\n";
            } else {
                store.commit('setMeText', me_text);
            }

            //image
            var me_img = response.data.me_img;
            if ($.type(me_img) !== 'string') {
                error_info += "'me_img' must be a string in config.json\n";
            } else {
                store.commit('setMeImg', me_img);
            }

            //show error
            if (error_info.length > 0) {
                alert(error_info);
            }

            if (store.state.enableResume) {
                axios_default.a.get('../../static/data/resume/resume.md').then(function (response1) {
                    store.commit('setResumeData', response1.data);
                }, function (error) {
                    console.log(error);
                });
            }
        }, function (error) {
            console.log(error);
        });

        //getting all articles
        axios_default.a.get('../../static/data/article_info.json').then(function (response) {
            var articles = values_default()(response.data.articles);
            var len = articles.length;

            var _loop = function _loop(i) {
                var article = articles[i];
                store.commit('setAllDetails', article);
                store.commit('setAllTypes', article.type);
                store.commit('setAllArticleTitle', article.title);

                axios_default.a.get(state.articlePath + article.filename).then(function (response1) {
                    store.commit('setAllArticles', {
                        "title": article.title,
                        "content": response1.data
                    });
                    if (i == len - 1) {
                        //set it true when complete getting the last one
                        store.commit('setAllArticlesFetched', true);
                    }
                }, function (error1) {
                    alert("Error getting " + article.filename + "\nPlease check article_info.json");
                    console.log(error1);
                });
            };

            for (var i = 0; i < len; i++) {
                _loop(i);
            }
        }, function (error) {
            console.log(error);
        });
    },
    actionSetSearch: function actionSetSearch(store, value) {
        store.commit('setSearch', value.value);
        var searchResults = {};

        if (value.value.trim().length > 0) {
            //only search when string not empty

            var allArticles = store.state.allArticles;
            var search = store.state.search.toLowerCase(); //to lowercase for search
            searchResults = {
                'showSearch': true,
                'hasResult': false,
                'results': {}
            };
            for (var title in allArticles) {
                //search here

                //to lowercase for search
                var lowCaseTitle = title.toLowerCase();
                allArticles[title] = allArticles[title].toLowerCase();

                var _article = {};
                //search by title higher priority than content
                if (lowCaseTitle.indexOf(search) !== -1) {
                    _article['content'] = allArticles[title].slice(0, store.state.maxReturnLength);
                    searchResults['results'][title] = _article;
                }
                //search by content
                else if (allArticles[title].indexOf(search) !== -1) {
                        var result = getSubstring(allArticles[title], store.state.maxReturnLength, allArticles[title].indexOf(search), search.length);

                        //add span to target string for color control
                        var spanOpen = "<span class='search_value'>";
                        var spanClose = "</span>";
                        var content = result['text'];
                        content = content.slice(0, result['targetStart']) + spanOpen + content.slice(result['targetStart']);
                        content = content.slice(0, result['targetStart'] + spanOpen.length + result['targetLength']) + spanClose + content.slice(result['targetStart'] + spanOpen.length + result['targetLength']);

                        _article['content'] = content;
                        // article['resultStart'] = result['targetStart'];
                        // article['resultLength'] = result['targetLength'];
                        searchResults['results'][title] = _article;
                    }
            }

            //has results
            if (keys_default()(searchResults['results']).length !== 0) {
                searchResults['hasResult'] = true;
            } else {
                searchResults['hasResult'] = false;
            }
        } else {
            searchResults = {
                'showSearch': false
            };
        }
        store.commit('setSearchResults', searchResults);
    }
};

/*
*   naifu
*   返回一个指定长度的以目标string为中心的左右等长的substring
*   
*   input:
*       fullString: string
*       returnLength: int
*       targetStringStart: int
*       targetStringLength: int
*   return object
*/
function getSubstring(fullString, returnLength, targetStringStart, targetStringLength) {
    var result = {
        text: null,
        targetStart: null,
        targetLength: targetStringLength
    };

    var fullStringLength = fullString.length;
    if (fullString.length <= returnLength || targetStringLength >= returnLength) {
        //rare situation
        result['text'] = fullString;
        result['targetStart'] = targetStringStart;
    } else {
        //normal situation
        var singleSideLength = Math.ceil((returnLength - targetStringLength) / 2);

        //hadle border issue
        var leftSide = targetStringStart - singleSideLength;
        leftSide = leftSide > 0 ? leftSide : 0;
        var rightSide = targetStringStart + targetStringLength + singleSideLength;
        rightSide = rightSide > fullStringLength - 1 ? fullStringLength - 1 : rightSide;

        var targetStart = 0;
        if (leftSide === 0) {
            targetStart = targetStringStart;
        } else {
            targetStart = singleSideLength;
        }

        result['text'] = fullString.substring(leftSide, rightSide);
        result['targetStart'] = targetStart;
    }

    return result;
}

/* harmony default export */ var vuex_store = (new vuex_esm["a" /* default */].Store({
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions
}));
// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

 //import Vue framework
 //import root component
 //import router setting


vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
var vm = new vue_esm["a" /* default */]({
    el: '#app', //mount DOM
    router: router,
    store: vuex_store,
    template: '<App></App>', //this will replace the mounted element totally if has this 'template' string
    components: {
        App: src_App
    },
    mounted: function mounted() {
        this.$store.dispatch('actionFetch');
    }
});

vue_esm["a" /* default */].filter('encodeURI', function (value) {
    return encodeURI(value);
});

vue_esm["a" /* default */].filter('decodeURI', function (value) {
    return decodeURI(value);
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.3807f22581b10edb01f2.js